module.exports = __webpack_public_path__ + "img/recommendation-2.5ac6ea6e.svg";